<template>
    <div>
        <the-banner :title="this.$lang.newsTitle"
                   :description="this.$lang.newsSubtitle"
                   image="cover.jpeg"/>
        <markdown-wrapper class="body-block"
                          id="markdown"
                          :source="data.markdown"/>
    </div>
</template>

<script>
	import TheBanner from "@/components/TheBanner";
	import NewsService from "@/services/NewsService";
	import MarkdownWrapper from "@/components/MarkdownWrapper";

	export default {
		name: "News",
		components: {MarkdownWrapper, TheBanner},
		created() {
			NewsService.getNews(this.$route.params.id).then(result => {
				this.data = result;
			});
		},
		data() {
			return {
				data: {
					name: "",
					markdown: this.$lang.loading
				}
			}
		}
	}
</script>

<style scoped>

</style>